import React from 'react';
import * as util from "../other/util.js";

// Shows all items
export default class ItemListView extends util.GameComponent {
    render() {
        let items = this.props.items;

        return (
            <table className="generic-list">
                <thead style={{ fontSize: "14px" }}>
                    <tr>
                        <td>Name</td>
                        <td>Key</td>
                        <td>Description</td>
                        <td>Value</td>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, idx) => <ItemView key={idx} item={item} />)}
                </tbody>
            </table>
        );
    }
}

class ItemView extends React.Component {
    render() {
        const item = this.props.item;

        return (
            <tr>
                <td>{item.name}</td>
                <td>{item.key}</td>
                <td>{item.description}</td>
                <td>{item.value}</td>
            </tr>
        );
    }
}